var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "CompassDialog",
    {
      staticClass: "avatar-uploader-dialog",
      attrs: {
        visible: _vm.showModal,
        size: "small",
        title: _vm.$t.__("utilities.AvatarUploader.image_modification")
      },
      on: {
        "update:visible": function($event) {
          _vm.showModal = $event
        },
        closed: function($event) {
          return _vm.$emit("close")
        }
      }
    },
    [
      _c("template", { slot: "default" }, [
        _c(
          "div",
          { staticClass: "dialog__default" },
          [
            _c(
              "p",
              {
                staticClass:
                  "grey mt-0 mb-3 typographies-paragraph-medium-regular"
              },
              [
                _vm._v(
                  "\n                " +
                    _vm._s(_vm.$l10n.__("Sélectionnez une image")) +
                    "\n            "
                )
              ]
            ),
            _vm._v(" "),
            _c(
              "el-upload",
              {
                ref: "uploadAvatar",
                staticClass: "avatar-uploader",
                attrs: {
                  name: "qqfile",
                  autoUpload: false,
                  multiple: false,
                  action: _vm.route,
                  drag: "",
                  headers: _vm.headerInfo,
                  showFileList: false,
                  onChange: function(file) {
                    return (_vm.pictureUploaded = file.raw)
                  },
                  onSuccess: _vm.onSuccess
                }
              },
              [
                _vm.avatarCompute.value && _vm.avatarCompute.type === "picture"
                  ? _c("img", { attrs: { src: _vm.avatarCompute.value } })
                  : _c(
                      "p",
                      {
                        staticClass:
                          "el-upload__text typographies-paragraph-medium-regular"
                      },
                      [
                        _vm._v(
                          "\n                    " +
                            _vm._s(
                              _vm.$l10n.__(
                                "Glissez - déposez une image ou cliquer"
                              )
                            ) +
                            "\n                "
                        )
                      ]
                    ),
                _vm._v(" "),
                _c(
                  "p",
                  {
                    staticClass:
                      "el-upload__tip typographies-paragraph-medium-regular",
                    attrs: { slot: "tip" },
                    slot: "tip"
                  },
                  [
                    _vm._v(
                      "\n                    (" +
                        _vm._s(
                          _vm.$l10n.__(
                            "Extension : jpg, jpeg, gif, png / Taille max : 15 Mo / Format recommandé : 400x400px"
                          )
                        ) +
                        ")\n                "
                    )
                  ]
                )
              ]
            )
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c("template", { slot: "footer" }, [
        _c(
          "div",
          { staticClass: "dialog__footer" },
          [
            _c("CompassButton", {
              attrs: {
                label: _vm.$t.__("utilities.AvatarUploader.delete_image"),
                type: "primary-destructive"
              },
              on: { click: _vm.removeImg }
            }),
            _vm._v(" "),
            _c("CompassButton", {
              staticClass: "ml-3",
              attrs: {
                label: _vm.$t.__("common.actions.save"),
                type: "primary"
              },
              on: { click: _vm.uploadAvatar }
            })
          ],
          1
        )
      ])
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }